import { useSelector } from "react-redux";
import { IRepoV2ReduxState } from "repoV2/features/Common/modules/Reducer/Reducer.interface";
import {
    DEFAULT_GST_STATUS,
    GST_STATUS,
} from "repoV2/features/Listing/Listing.constants";
import { useCheckoutBasicDetailsContext } from "../modules/CheckoutBasicDetailsContextProvider";

/**
 * This hook is used to get the one time price after handling the GST Exclusive case,
 * to be shown in One time payment block, and the short description
 */
const useOneTimeListingPrice = () => {
    const { listingUuid } = useCheckoutBasicDetailsContext();

    const priceDetails = useSelector(
        (mainState: IRepoV2ReduxState) =>
            mainState.checkoutPages.listingDetails[listingUuid]?.priceSection
                ?.data
    );

    const {
        currency,
        currency_name: currencyName = "",
        gst_state: gstState = DEFAULT_GST_STATUS,
        creator_gst: creatorTaxPercentage = 0,
    } = priceDetails || {};

    let { payable_amount: offerBasePrice = 0, price_per_head: basePrice = 0 } =
        priceDetails || {};

    if (gstState === GST_STATUS.EXCLUSIVE) {
        basePrice *= (100 + creatorTaxPercentage) / 100;
        offerBasePrice *= (100 + creatorTaxPercentage) / 100;
    }

    const showStrikeOffPrice = basePrice > offerBasePrice;

    return {
        currency,
        currencyName,
        showStrikeOffPrice,
        basePrice,
        offerBasePrice,
    };
};

export default useOneTimeListingPrice;
